module.exports = __webpack_public_path__ + "static/media/Vector_2 - Copy.c6e8f540.png";